<template>
    <b-container class="container">
        <b-row>
            <!-- Side menu -->
            <b-col md="2" class="side-menu-col">
                <div class="menu-title side-menu" @click="$router.push('/dashboard')">
                    <img src="@/assets/back-primary.svg" class="back-arrow" />
                    <span>Indietro</span>
                </div>
                <div class="side-menu" :class="{selected_item: isSelected('utenti')}" @click="selected_item='utenti';">
                    <span>Utenti</span>
                </div>
                <div class="side-menu" :class="{selected_item: isSelected('richieste')}" @click="selected_item='richieste';">
                    <span>Richieste d'accesso</span>
                </div>
                <div class="side-menu" :class="{selected_item: isSelected('laboratori')}" @click="selected_item='laboratori';">
                    <span>Laboratori</span>
                </div>
            </b-col>
            <!-- /Side menu -->
            <!-- Body -->
            <b-col class="body-container">
                <Title :text="getTitle(selected_item)" />
                <div class="list-container" >
                    <ListaUtenti v-if="isSelected('utenti')" />
                    <RichiesteAccesso v-if="isSelected('richieste')" />
                    <ListaLabs v-if="isSelected('laboratori')" />
                </div>
            </b-col>
            <!-- /Body -->
        </b-row>
    </b-container>
</template>

<script>
import Title from '@/components/Title.vue'
import ListaUtenti from '@/components/Lista-Utenti.vue'
import RichiesteAccesso from '@/components/Richieste-Accesso.vue'
import ListaLabs from '@/components/Lista-Laboratori.vue'

export default {
    name: 'Admin',
    data(){
        return {
            selected_item: "utenti",

        }
    },
    components: {
        ListaUtenti,
        Title,
        RichiesteAccesso,
        ListaLabs
    },
    methods: {
        isSelected: function(param){
            if(param.localeCompare(this.selected_item)==0)
                return true;
            return false;
        },
        getTitle: function(selected){
            if (selected.localeCompare('utenti')==0)
                return 'Utenti'
            if (selected.localeCompare('richieste')==0)
                return 'Richieste'
            if (selected.localeCompare('laboratori')==0)
                return 'Laboratori'
        }
    }

}
</script>

<style scoped>
    .container {
        width: 100vw;
        max-width: none;
        padding: 0;
        margin-top: -40px;
    }
    .back-arrow {
        width: 20px;
    }
    .side-menu{
        padding: 15px 0;
        border-bottom: 1px solid #c6c6c6;
        cursor: pointer;
    }
    .selected_item{
        background-color: #6abf61;
        color: white;
    }
    .menu-title{
        background-color: #fafafa;
        padding: 25px 0;
    }
    .side-menu-col{
        border-right: 1px solid #c6c6c6;
        height: 100vh;
        padding: 0;
    }
    .list-container{
        width: 70%;
        max-width: 900px;
        padding-top: 30px;
    }
    .body-container{
        margin-top: 40px;
        margin-left: 100px;
    }
</style>